export const MAX_SIGNALS_IN_CHAR = 5;
export const DITS_TO_ADD_CHARACTER = 3;
export const DITS_TO_ADD_WORD = 7;
export const DITS_IN_DASH = 3;

export const COLORS = {
  black: "var(--color-black)",
  "grey-20": "var(--color-grey-20)",
  "grey-30": "var(--color-grey-30)",
  "grey-40": "var(--color-grey-40)",
  "grey-50": "var(--color-grey-50)",
  white: "var(--color-white)",
  primary: "var(--color-primary)",
};
